import React from "react";

function Required(){
    return(
        <span className={'red-highlight'}>*</span>
    )
}

export default Required;